module.exports = __webpack_public_path__ + "static/media/supportTicket.ec10c75a.png";